export default "__VITE_ASSET__38929595__$_?nuxt_component=async&nuxt_component_name=SvgoClockSecond__"